import { DateTime } from "luxon";

import { PaintMatchPill } from "./PartRequestPills";
import { LeadStatus } from "../../models/Lead";
import { IPartRequestLeadMatch, PartRequestMatchStrength } from "../../models/partRequests/IPartRequest";
import openInNewTab from "../../utils/openInNewTab";
import { PART_REQUEST_MATCH_LABELS } from "../../utils/partRequests";

interface MatchedLeadsProps {
  matches: IPartRequestLeadMatch[];
  /** The full total - only the first few are sent. */
  total: number;
}

/** Cars on leads that haven't been booked in yet - the request may be the reason to chase one. */
export default function MatchedLeads({ matches, total }: MatchedLeadsProps) {
  if (matches.length === 0) {
    return <span className="text-sm text-gray-400">No unbooked leads match this vehicle.</span>;
  }

  return (
    <div>
      <ul className="divide-y divide-gray-100">
        {matches.map((match) => (
          <li key={match.leadId} className="flex flex-wrap items-center justify-between gap-2 py-2 text-sm">
            <div className="min-w-0">
              <p className="font-medium text-gray-900">
                {[match.vrm, match.year, match.make, match.model].filter(Boolean).join(" · ")}
              </p>
              <p className="text-xs text-gray-500">
                {LeadStatus[match.leadStatus]} · lead {DateTime.fromISO(match.leadCreated).toRelative()}
              </p>
            </div>
            <div className="flex flex-wrap items-center gap-2">
              <span
                className={
                  match.strength === PartRequestMatchStrength.Exact
                    ? "rounded-md bg-green-50 px-2 py-1 text-xs font-semibold text-green-800 ring-1 ring-inset ring-green-300"
                    : "rounded-md bg-blue-50 px-2 py-1 text-xs font-semibold text-blue-800 ring-1 ring-inset ring-blue-200"
                }
              >
                {PART_REQUEST_MATCH_LABELS[match.strength]}
              </span>
              {match.paintMatch && <PaintMatchPill />}
              <button type="button" onClick={() => openInNewTab(`/leads/${match.leadId}`)} className="text-primary-600 hover:underline">
                Open lead
              </button>
            </div>
          </li>
        ))}
      </ul>
      {total > matches.length && (
        <p className="mt-2 text-xs text-gray-500">
          {total - matches.length} more lead{total - matches.length === 1 ? "" : "s"} match this vehicle.
        </p>
      )}
    </div>
  );
}
